var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ephemeral-ide", {
    attrs: {
      "accepted-languages": _vm.acceptedLanguages,
      "initial-language": _vm.initialLanguage,
      problem: _vm.problem,
      "should-show-submit-button": _vm.canSubmit,
      "can-run": _vm.canRun,
      "is-embedded": _vm.isEmbedded,
      "initial-theme": _vm.initialTheme,
      "next-submission-timestamp": _vm.nextSubmissionTimestamp,
      "next-execution-timestamp": _vm.nextExecutionTimestamp
    },
    on: {
      "execute-run": function() {
        return this$1.$emit("execute-run")
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }